import { useCallback, useEffect } from 'react';

// local imports
import { SystemUserService } from 'app/services';
import useDataApi from '../../use-data-api';
import { FormatUtils } from 'app/utils';

const useSystemUserDetailService = userId => {
  const [service, setService] = useDataApi();

  const fetchData = useCallback(async () => {
    // ticket topics
    const systemUserDetail = await SystemUserService.getSystemUserDetail(userId);
    const systemUserDetailData = systemUserDetail?.data?.data;

    const { telephone, birthdate, ...rest } = systemUserDetailData;

    return {
      telephone: FormatUtils.formatPhoneNumber(telephone),
      birthdate: FormatUtils.convertDate(birthdate),
      ...rest
    };
  }, [userId]);

  useEffect(() => setService(() => fetchData()), [fetchData, setService]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default useSystemUserDetailService;
